import { ClosingDay } from './ClosingDays'
import { EventDay } from './EventDay'
import { Absence, OccasionalSlot, RegularCancellationRequest, RegularSlot, RegularUpdate, RequestSlot } from './Slots'
import { Work } from './work'
import { RateSlot } from './StaffRate'
import { TaskNote } from './TaskNote.ts'

export type EventCalendar = {
    title: string
    start: Date
    end: Date
    number: string
    type: CalendarEventType
    childId?: number
    sectionId?: number
    placeId?: number
    staffId?: number
    levelId?: number
    sectionGroupId?: number
    slots:
        | ClosingDay
        | EventDay
        | RegularSlot[]
        | OccasionalSlot[]
        | RegularCancellationRequest[]
        | Absence[]
        | RegularUpdate[]
        | RequestSlot[]
        | Work
        | RateSlot[]
        | TaskNote
}

export enum CalendarEventType {
    REGULAR = 'REGULAR',
    ABSENCE = 'ABSENCE',
    REGULAR_REQUEST = 'REGULAR_REQUEST',
    EXPIRED = 'EXPIRED',
    REQUEST = 'REQUEST',
    EVENT = 'EVENT',
    CLOSING_DAY = 'CLOSING_DAY',
    SCHEDULED = 'SCHEDULED',
    VALIDATED = 'VALIDATED',
    AVAILABLE = 'AVAILABLE',
    REMAINDER_AVAILABLE = 'REMAINDER_AVAILABLE',
    IN_SECTION = 'IN_SECTION',
    STAFF_HOLIDAY = 'STAFF_HOLIDAY',
    STAFF_TRAINING = 'STAFF_TRAINING',
    NOT_IN_SECTION = 'NOT_IN_SECTION',
    RATE_SLOT = 'RATE_SLOT',
    TASK_NOTE = 'TASK_NOTE'
}

export type AllSlots = {
    getSlots: {
        OccasionalSlots: OccasionalSlot[]
        RegularSlots: RegularSlot[]
        RequestSlots: RequestSlot[]
    }
    getWorks: Work[]
    getClosingDay: ClosingDay[]
    getEventDay: EventDay[]
    getTaskNotesByDaycare?: TaskNote[]
}
